export const getCulture = (): Culture => (window["culture"] || "nl-nl").toLowerCase()

export enum Culture {
  nlNl = "nl-nl",
  nlBe = "nl-be",
  frBe = "fr-be",
  frFr = "fr-fr",
}

const NL = {
  pageTitle: "kies je winkel",
  pageDescription: "Waar wil je je foto’s laten afdrukken?",
  pageCheckoutDescription: "Kies hier de winkel waar je de bestelling op wilt halen. We sturen een e-mail wanneer de bestelling voor je klaar ligt.",
  searchTitle: "zoek een HEMA winkel bij jou in de buurt",
  searchDescription: "Zoek op plaats, postcode, of gebruik je huidige locatie.",
  geo: "gebruik locatie",
  searchPlaceholder: "zoek op adres of plaats",
  geoNotSupported: "Je browser ondersteund deze functie niet of u heeft geen toestemming verleend.",
  hour: "uur",
  closed: "gesloten",
  pickupToday: time => `vandaag voor <span>${time}</span> besteld is vandaag nog ophalen`,
  pickupNextDay: (day, time) => `ophalen vanaf ${day} ${time}`,
  todayOpenUntil: (time) => `open tot ${time}`,
  todayOpenFuture: (a, b) => `open vanaf ${a} tot ${b}`,
  nextDayOpenFrom: (day, time) => `${day} open vanaf ${time}`,
  openTimes: "openingstijden",
  chooseStore: "kies winkel",
  chooseThisStore: "kies deze winkel",
  nowStillClosed: "Deze winkel is nu nog gesloten",
  nowClosed: "Deze winkel is nu gesloten",
  pickupStillClosed: "Je kan je bestelling vandaag ophalen, 30 minuten na opening.",
  pickupNowClosed: "Je kan je bestelling op de eerstvolgende dag dat de winkel geopend is ophalen, 30 minuten na opening.",
  pickOtherStore: "Nee, een andere winkel kiezen",
  confirmPickStore: "Ja, deze winkel kiezen",
  storeTempUnavailable: "de snelservice is tijdelijk niet beschikbaar.",
  viewOnMap: "bekijk details",
  dayNames: ["maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag", "zondag"],
  today: "vandaag",
  clear: "leeg maken",
  hemaStoreCounter: "Hema winkelbalie",
  howExpressServiceWorks: "hoe snelservice werkt",
  expressServiceBullet1: "Kies een HEMA winkel bij jou in de buurt",
  expressServiceBullet2: "Kies de foto's die je wilt afdrukken.",
  expressServiceBullet3: "Kies het afdrukformaat en het aantal.",
  expressServiceBullet4: "Controleer en bevestig je bestelling.",
  expressServiceBullet5: "Haal de afdrukken op en betaal in de winkel.",
  hasXlService: "ook XL prints",
};

const FR: typeof NL = {
  pageTitle: "choisissez votre magasin",
  pageDescription: "Où voulez-vous faire imprimer vos photos ?",
  pageCheckoutDescription: "Choisissez ici le magasin où vous souhaitez retirer votre commande. Nous vous enverrons un e-mail lorsque votre commande sera prête.",
  searchTitle: "chercher un magasin HEMA à proximité",
  searchDescription: "Chercher par localité, code postal, ou en utilisant votre localisation actuelle.",
  geo: "utiliser ma position",
  searchPlaceholder: "recherchez par adresse ou lieu",
  geoNotSupported: "Votre navigateur ne prend pas en charge cette fonction ou vous n’avez pas accordé d’autorisation.",
  hour: "heure",
  closed: "fermé",
  pickupToday: time => `Aujourd'hui à commandé avant <span>${time}</span> heures, retrait le jour-même.`,
  pickupNextDay: (day, time) => `prise en charge à partir de ${day} ${time} heure`,
  todayOpenUntil: (time) => `aujourd'hui ouvert jusqu'à  ${time} heure`,
  todayOpenFuture: (a, b) => `ouvert aujourd'hui de ${a} à ${b} heure`,
  nextDayOpenFrom: (day, time) => `${day} ouvert à partir de ${time} heure`,
  openTimes: "horaires d'ouvertures",
  chooseStore: "mon magasin",
  chooseThisStore: "choisissez ce magasin",
  nowStillClosed: "Cette boutique est toujours fermée maintenant",
  nowClosed: "Ce magasin est maintenant fermé",
  pickupStillClosed: "Vous pouvez récupérer votre commande aujourd'hui, 30 minutes après l'ouverture.",
  pickupNowClosed: "Vous pouvez récupérer votre commande de photos le prochain jour ouvré du magasin sélectionné, 30 minutes après l'ouverture.",
  pickOtherStore: "Non, choisissez un autre magasin",
  confirmPickStore: "Oui, choisissez ce magasin",
  storeTempUnavailable: "le service express n'est temporairement pas disponible.",
  viewOnMap: "voir les détails",
  dayNames: ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"],
  today: "aujourd'hui",
  clear: "vide",
  hemaStoreCounter: "comptoir de magasin Hema",
  howExpressServiceWorks: "comment fonctionne le service express",
  expressServiceBullet1: "Choisissez un magasin HEMA près de chez vous",
  expressServiceBullet2: "Choisissez vos photos.",
  expressServiceBullet3: "Choisissez le format d'impression et la quantité.",
  expressServiceBullet4: "Vérifiez et confirmez votre commande.",
  expressServiceBullet5: "Récupérez les impressions et payez en magasin.",
  hasXlService: "impressions XL également",
};

const translations: Record<Window['culture'], typeof NL> = {
  NL,
  FR
};

export const getTranslation = <T extends LanguageKey>(key: T): typeof NL[T] => {
  if (window.culture === "fr-BE")
    return translations["FR"][key]

  return translations["NL"][key]
}

export type LanguageKey = keyof typeof NL